import { render, staticRenderFns } from "./EVC.vue?vue&type=template&id=6a1bdb06&"
import script from "./EVC.vue?vue&type=script&lang=js&"
export * from "./EVC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports